import {
  IGroupInfo,
  IMessage,
  RPM_DEVICE_TYPE,
} from "@home-health-notify/domain";
import CommonDrawerHeader from "../../../common/CommonDrawerHeader";
import { useContext, useEffect, useState } from "react";
import { ChatInfoContext, OrganizationContext } from "hhn-commons";
import { RightDrawerContext } from "../../../context/RightDrawerContext";
import { Box, Typography } from "@mui/material";
import { rpmDeviceTypeDescriptions } from "./AssignedDeviceItem";
import { DrawerDivider } from "../../../layout/RightDrawer.style";
import MessagePanelItem from "../../../message/messagePanelItem/MessagePanelItem";
import ProgressLoader from "../../../loader/ProgressLoader";
import { DeviceInfoWrapper, Title } from "./Vitals.style";

interface IVitalReadingsProps {
  deviceName: RPM_DEVICE_TYPE;
  deviceId?: string;
}

const VitalReadings = ({ deviceName, deviceId }: IVitalReadingsProps) => {
  const { openChatInfoDrawer, closeDrawer } = useContext(RightDrawerContext);
  const { chat } = useContext(ChatInfoContext);
  const { selectedOrgUser } = useContext(OrganizationContext);

  const [isReadingsFetching, setIsReadingsFetching] = useState(false);

  const rpmDeviceData = (chat?.chatInfo as IGroupInfo)?.rpmDevices.find(
    device => device.rpmDeviceType === deviceName,
  );
  const rpmReadingsData: IMessage[] = rpmDeviceData?.readings || [];

  const openChatInfo = () => {
    openChatInfoDrawer(2);
  };

  useEffect(() => {
    (async () => {
      if (!chat) return;
      setIsReadingsFetching(true);
      await chat.fetchRpmReading({
        rpmDeviceType: deviceName,
      });
      setIsReadingsFetching(false);
    })();
  }, [chat, deviceName]);

  const UnSupported = () => {
    throw new Error(
      "Panic: message selection not allowed on vital reading messages",
    );
  };

  return (
    <>
      <CommonDrawerHeader
        showBackButton={true}
        onBackButtonClick={openChatInfo}
        title={"Device Readings"}
        onCloseButtonClick={closeDrawer}
      />
      <DeviceInfoWrapper>
        <Title>Device Name: {rpmDeviceTypeDescriptions[deviceName]}</Title>
        {deviceId && <Title>Device Id: {deviceId}</Title>}
      </DeviceInfoWrapper>
      <DrawerDivider />
      <Box style={{ padding: 24 }}>
        {isReadingsFetching && <ProgressLoader />}
        {!isReadingsFetching &&
          rpmReadingsData.map(reading => {
            const readingData = reading.getMessage();
            return (
              <MessagePanelItem
                message={reading}
                key={readingData.id}
                selectedOrgUser={selectedOrgUser!}
                hideAvatar
                disableActions
                showMessageInfo={false}
                chatInfoAccess={chat!}
                selectMessage={UnSupported}
                hideContextMenu={true}
                isReplyPreview={true}
              />
            );
          })}
        {!isReadingsFetching && rpmReadingsData.length === 0 && (
          <Typography>No readings available</Typography>
        )}
      </Box>
    </>
  );
};

export default VitalReadings;
